//Allow override of localStorage for testing purposes
export const getLocalStorage = () => {
  return localStorage;
};
